// tslint:disable
// @ts-nocheck
/**
 * Enter API Documentation
 * ## Interactive Documentation ##### Our API documentation allows you to test API calls straight from this website. ##### To do this, scroll down a little and click the green \"Authorize\" button (with a padlock) to the right and below. A pop-up should appear. ##### In the popup, enter your \"client_id\" and \"client_secret\" values (these will be provided to you) and press \"Authorize\". You should now be logged in (you can open up your network tab to see the API traffic going through). ##### From here, you can click any endpoint below to expand its details and click the \"Try it out\" button that appears in the expanded section. ##### Fill out the parameter fields and then click \"Execute\" to call the endpoint. The results of your query should be shown below. ## Authentication ##### Our API uses the OAuth 2.0 Client Credentials flow to authorize clients. ##### With your provided \"Client Id\" and \"Client Secret\", make the following call: ``` POST /oauth/token HTTP/1.1 Host: api.enter.health  grant_type=client_credentials &client_id=XXXXXXXXXXXX &client_secret=YYYYYYYYYYY ``` ##### Here\'s an example CURL request: ``` curl \'https://api.enter.health/oauth/token\' -H \'accept: application/json\' --data \'grant_type=client_credentials&client_id=XXXXXXXXXXXX&client_secret=YYYYYYYYYYY\' ``` ##### The response should look something like this ``` {   \"access_token\" : \"AAAAAAAAAAAAAAAAAAA\",   \"refresh_token\" : \"BBBBBBBBBBBBBBBBBBB\" }  ``` ##### With the access token provided, you can make an authenticated call to any of the endpoints below by including the header \"Authorization: Bearer AAAAAAAAAAAAAAAAAAA\" with your API request. ##### Here\'s an example of a basic curl request to the \"/me\" endpoint ``` curl \'https://api.enter.health/me\' -H \'accept: application/json\' -H \'authorization: Bearer AAAAAAAAAAAAAAAAAAA\' ``` ##### Note that access tokens are not long-living tokens. The lifetime of them differs from client to client, but they may last as short as 15 minutes (if you would like an increase in time, please reach out to us). ### Comparators ##### Filter parameters need to be formatted with a comparator and value in the format of \"COMPARATOR:VALUE\". The following is a list of possible values:  ##### GTE - Greater than or equal ##### GT - Greater than ##### LT - Less Than ##### LTE - Less than or equal ##### EQ - Equal ##### NQ - Not Equal ##### LK - Like ##### NLK - Not Like ##### EMPTY - Is null ##### NEMPTY - Is not null ## Subject to Change ##### Note that this API is in active development and may be subject to changes at any time. ##### This document is a living document with current specifications. If your integration does not seem to work properly, please refer back to this page to look for updates. ##### If you are still having issues, please reach out to support.
 *
 * The version of the OpenAPI document: 2
 * Contact: support@enter.health
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    CoderRulesDashboardItem,
    GlobalCoderRule,
    ObjectNoResponse,
    ProviderCoderRule,
    ProviderCoding,
    ProviderCodingSortType,
    SupportCoderRule,
    SupportCoding,
    SupportCodingSortType,
    SupportCreateCoderRulePayload,
    SupportCreateCodingPayload,
    SupportCreateGlobalCoderRulePayload,
    ArrayToJSON,
    SupportCreateCodingPayloadToJSON,
    CoderRulesDashboardItemFromJSON,
    GlobalCoderRuleFromJSON,
    ObjectNoResponseFromJSON,
    ProviderCoderRuleFromJSON,
    ProviderCodingFromJSON,
    SupportCoderRuleFromJSON,
    SupportCodingFromJSON,
} from '../models';

export interface GetProviderCodingRequest {
    id: string;
}

export interface GetProviderGlobalCoderRulesRequest {
    filterClaimId?: string;
}

export interface GetSupportCodingRequest {
    id: string;
}

export interface GetSupportGlobalCoderRulesRequest {
    filterClaimId?: string;
}

export interface ListProviderCodingsRequest {
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<ListProviderCodingsOrderEnum>;
    filterCreated?: Array<string>;
    filterClaimId?: Array<string>;
    filterCodingStatusType?: Array<string>;
    filterCodingVendorType?: Array<string>;
    filterResult?: Array<string>;
    sort?: Array<ProviderCodingSortType>;
}

export interface ListSupportCodingsRequest {
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<ListSupportCodingsOrderEnum>;
    filterCreated?: Array<string>;
    filterActive?: string;
    filterStarred?: string;
    filterClaimId?: Array<string>;
    filterTag?: Array<string>;
    filterCodingStatusType?: Array<string>;
    filterCodingVendorType?: Array<string>;
    filterResult?: Array<string>;
    sort?: Array<SupportCodingSortType>;
}

export interface PostSupportCoderRulesRequest {
    supportCreateCoderRulePayload: Array<SupportCreateCoderRulePayload>;
}

export interface PostSupportCodingRequest {
    supportCreateCodingPayload: SupportCreateCodingPayload;
}

export interface PostSupportCodingCancelRequest {
    id: string;
}

export interface PostSupportCodingClaimTypeRequest {
    id: string;
}

export interface PostSupportGlobalCoderRulesRequest {
    supportCreateGlobalCoderRulePayload: Array<SupportCreateGlobalCoderRulePayload>;
}

/**
 * no description
 */
export class CodingApi extends runtime.BaseAPI {

    /**
     * Get coder rules
     * Get coder rules
     */
    async getProviderCoderRulesRaw(): Promise<runtime.ApiResponse<Array<ProviderCoderRule>>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:coding"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/coding/rules`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProviderCoderRuleFromJSON));
    }

    /**
     * Get coder rules
     * Get coder rules
     */
    async getProviderCoderRules(): Promise<Array<ProviderCoderRule>> {
        const response = await this.getProviderCoderRulesRaw();
        return await response.value();
    }

    /**
     * Get coder rules dashboard
     * Get coder rules dashboard
     */
    async getProviderCoderRulesDashboardRaw(): Promise<runtime.ApiResponse<Array<CoderRulesDashboardItem>>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:coding"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/coding/rules/dashboard`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CoderRulesDashboardItemFromJSON));
    }

    /**
     * Get coder rules dashboard
     * Get coder rules dashboard
     */
    async getProviderCoderRulesDashboard(): Promise<Array<CoderRulesDashboardItem>> {
        const response = await this.getProviderCoderRulesDashboardRaw();
        return await response.value();
    }

    /**
     * Gets an Coding
     * Gets an Coding
     */
    async getProviderCodingRaw(requestParameters: GetProviderCodingRequest): Promise<runtime.ApiResponse<ProviderCoding>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getProviderCoding.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:coding"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/coding/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderCodingFromJSON(jsonValue));
    }

    /**
     * Gets an Coding
     * Gets an Coding
     */
    async getProviderCoding(requestParameters: GetProviderCodingRequest): Promise<ProviderCoding> {
        const response = await this.getProviderCodingRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get global coder rules that apply to all providers
     * Get global coder rules
     */
    async getProviderGlobalCoderRulesRaw(requestParameters: GetProviderGlobalCoderRulesRequest): Promise<runtime.ApiResponse<Array<GlobalCoderRule>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterClaimId !== undefined) {
            queryParameters['filterClaimId'] = requestParameters.filterClaimId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:coding"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/coding/global_rules`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GlobalCoderRuleFromJSON));
    }

    /**
     * Get global coder rules that apply to all providers
     * Get global coder rules
     */
    async getProviderGlobalCoderRules(requestParameters: GetProviderGlobalCoderRulesRequest): Promise<Array<GlobalCoderRule>> {
        const response = await this.getProviderGlobalCoderRulesRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get coder rules
     * Get coder rules
     */
    async getSupportCoderRulesRaw(): Promise<runtime.ApiResponse<Array<SupportCoderRule>>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:coding", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/coding/rules`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SupportCoderRuleFromJSON));
    }

    /**
     * Get coder rules
     * Get coder rules
     */
    async getSupportCoderRules(): Promise<Array<SupportCoderRule>> {
        const response = await this.getSupportCoderRulesRaw();
        return await response.value();
    }

    /**
     * Get coder rules dashboard
     * Get coder rules dashboard
     */
    async getSupportCoderRulesDashboardRaw(): Promise<runtime.ApiResponse<Array<CoderRulesDashboardItem>>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:coding", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/coding/rules/dashboard`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CoderRulesDashboardItemFromJSON));
    }

    /**
     * Get coder rules dashboard
     * Get coder rules dashboard
     */
    async getSupportCoderRulesDashboard(): Promise<Array<CoderRulesDashboardItem>> {
        const response = await this.getSupportCoderRulesDashboardRaw();
        return await response.value();
    }

    /**
     * Gets an Coding
     * Gets an Coding
     */
    async getSupportCodingRaw(requestParameters: GetSupportCodingRequest): Promise<runtime.ApiResponse<SupportCoding>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getSupportCoding.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:coding", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/coding/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportCodingFromJSON(jsonValue));
    }

    /**
     * Gets an Coding
     * Gets an Coding
     */
    async getSupportCoding(requestParameters: GetSupportCodingRequest): Promise<SupportCoding> {
        const response = await this.getSupportCodingRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get global coder rules that apply to all providers
     * Get global coder rules
     */
    async getSupportGlobalCoderRulesRaw(requestParameters: GetSupportGlobalCoderRulesRequest): Promise<runtime.ApiResponse<Array<GlobalCoderRule>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterClaimId !== undefined) {
            queryParameters['filterClaimId'] = requestParameters.filterClaimId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:coding", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/coding/global_rules`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GlobalCoderRuleFromJSON));
    }

    /**
     * Get global coder rules that apply to all providers
     * Get global coder rules
     */
    async getSupportGlobalCoderRules(requestParameters: GetSupportGlobalCoderRulesRequest): Promise<Array<GlobalCoderRule>> {
        const response = await this.getSupportGlobalCoderRulesRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a list of codings
     * Get a list of codings
     */
    async listProviderCodingsRaw(requestParameters: ListProviderCodingsRequest): Promise<runtime.ApiResponse<Array<ProviderCoding>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.filterClaimId) {
            queryParameters['filterClaimId'] = requestParameters.filterClaimId;
        }

        if (requestParameters.filterCodingStatusType) {
            queryParameters['filterCodingStatusType'] = requestParameters.filterCodingStatusType;
        }

        if (requestParameters.filterCodingVendorType) {
            queryParameters['filterCodingVendorType'] = requestParameters.filterCodingVendorType;
        }

        if (requestParameters.filterResult) {
            queryParameters['filterResult'] = requestParameters.filterResult;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:coding"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/coding`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProviderCodingFromJSON));
    }

    /**
     * Gets a list of codings
     * Get a list of codings
     */
    async listProviderCodings(requestParameters: ListProviderCodingsRequest): Promise<Array<ProviderCoding>> {
        const response = await this.listProviderCodingsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a list of codings
     * Get a list of codings
     */
    async listSupportCodingsRaw(requestParameters: ListSupportCodingsRequest): Promise<runtime.ApiResponse<Array<SupportCoding>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.filterActive !== undefined) {
            queryParameters['filterActive'] = requestParameters.filterActive;
        }

        if (requestParameters.filterStarred !== undefined) {
            queryParameters['filterStarred'] = requestParameters.filterStarred;
        }

        if (requestParameters.filterClaimId) {
            queryParameters['filterClaimId'] = requestParameters.filterClaimId;
        }

        if (requestParameters.filterTag) {
            queryParameters['filterTag'] = requestParameters.filterTag;
        }

        if (requestParameters.filterCodingStatusType) {
            queryParameters['filterCodingStatusType'] = requestParameters.filterCodingStatusType;
        }

        if (requestParameters.filterCodingVendorType) {
            queryParameters['filterCodingVendorType'] = requestParameters.filterCodingVendorType;
        }

        if (requestParameters.filterResult) {
            queryParameters['filterResult'] = requestParameters.filterResult;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:coding", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/coding`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SupportCodingFromJSON));
    }

    /**
     * Gets a list of codings
     * Get a list of codings
     */
    async listSupportCodings(requestParameters: ListSupportCodingsRequest): Promise<Array<SupportCoding>> {
        const response = await this.listSupportCodingsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Report current created coder rules
     * Report current created coder rules
     */
    async postSupportCoderRulesRaw(requestParameters: PostSupportCoderRulesRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['supportCreateCoderRulePayload'] === null || requestParameters['supportCreateCoderRulePayload'] === undefined) {
            throw new runtime.RequiredError('supportCreateCoderRulePayload','Required parameter requestParameters.supportCreateCoderRulePayload was null or undefined when calling postSupportCoderRules.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:coderrule", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/coding/rules`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.supportCreateCoderRulePayload.map(SupportCreateCoderRulePayloadToJSON),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Report current created coder rules
     * Report current created coder rules
     */
    async postSupportCoderRules(requestParameters: PostSupportCoderRulesRequest): Promise<ObjectNoResponse> {
        const response = await this.postSupportCoderRulesRaw(requestParameters);
        return await response.value();
    }

    /**
     * Create a coding
     * Create a coding
     */
    async postSupportCodingRaw(requestParameters: PostSupportCodingRequest): Promise<runtime.ApiResponse<SupportCoding>> {
        if (requestParameters['supportCreateCodingPayload'] === null || requestParameters['supportCreateCodingPayload'] === undefined) {
            throw new runtime.RequiredError('supportCreateCodingPayload','Required parameter requestParameters.supportCreateCodingPayload was null or undefined when calling postSupportCoding.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:coding", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/coding`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportCreateCodingPayloadToJSON(requestParameters['supportCreateCodingPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportCodingFromJSON(jsonValue));
    }

    /**
     * Create a coding
     * Create a coding
     */
    async postSupportCoding(requestParameters: PostSupportCodingRequest): Promise<SupportCoding> {
        const response = await this.postSupportCodingRaw(requestParameters);
        return await response.value();
    }

    /**
     * Cancel a pending coding
     * Cancel a pending coding
     */
    async postSupportCodingCancelRaw(requestParameters: PostSupportCodingCancelRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling postSupportCodingCancel.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:coding", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/coding/{id}/cancel`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Cancel a pending coding
     * Cancel a pending coding
     */
    async postSupportCodingCancel(requestParameters: PostSupportCodingCancelRequest): Promise<ObjectNoResponse> {
        const response = await this.postSupportCodingCancelRaw(requestParameters);
        return await response.value();
    }

    /**
     * Create a claim type from a coding
     * Create a claim type from a coding
     */
    async postSupportCodingClaimTypeRaw(requestParameters: PostSupportCodingClaimTypeRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling postSupportCodingClaimType.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:coding", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/coding/{id}/claim`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Create a claim type from a coding
     * Create a claim type from a coding
     */
    async postSupportCodingClaimType(requestParameters: PostSupportCodingClaimTypeRequest): Promise<ObjectNoResponse> {
        const response = await this.postSupportCodingClaimTypeRaw(requestParameters);
        return await response.value();
    }

    /**
     * Report global coder rules from the coding library
     * Report global coder rules
     */
    async postSupportGlobalCoderRulesRaw(requestParameters: PostSupportGlobalCoderRulesRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['supportCreateGlobalCoderRulePayload'] === null || requestParameters['supportCreateGlobalCoderRulePayload'] === undefined) {
            throw new runtime.RequiredError('supportCreateGlobalCoderRulePayload','Required parameter requestParameters.supportCreateGlobalCoderRulePayload was null or undefined when calling postSupportGlobalCoderRules.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:coderrule", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/coding/global_rules`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.supportCreateGlobalCoderRulePayload.map(SupportCreateGlobalCoderRulePayloadToJSON),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Report global coder rules from the coding library
     * Report global coder rules
     */
    async postSupportGlobalCoderRules(requestParameters: PostSupportGlobalCoderRulesRequest): Promise<ObjectNoResponse> {
        const response = await this.postSupportGlobalCoderRulesRaw(requestParameters);
        return await response.value();
    }

}

/**
    * @export
    * @enum {string}
    */
export enum ListProviderCodingsOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
/**
    * @export
    * @enum {string}
    */
export enum ListSupportCodingsOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
